import { useState, useEffect } from 'react';
import * as signalR from "@microsoft/signalr";

const Test = () => {
    const URL = process.env.REACT_APP_ROOT_MSG + "/DataHub/?connectionId=1";
    const [callers, setCallers] = useState([]);
    const [showNotifBox, setShowNotifBox] = useState(false);

    const showBox = (open) => {
        setShowNotifBox(open);
    }

    const setMerchantCall = (data) => {
        console.log(data);
        callers.push(data);
        setCallers([...callers]);
        showBox(true);
    }

    const createConnection = () => {
        let conn = new signalR.HubConnectionBuilder()
            .withUrl(URL)
            .withAutomaticReconnect()
            .build();
        conn.start().catch(err => console.log(err)).then(() => {
            conn.invoke('GetConnectionId').then(function (connectionId) {
                console.log('connectionId: ' + connectionId);
            });
        });
        conn.on("ReceiveCallerNumber", (branchId, merchantInfo) => {
            setMerchantCall(merchantInfo);
        });
    }

    useEffect(() => {
        console.log("I only ran once!");
    }, []);


    useEffect(() => {
        createConnection();
    }, []);

    const getPagerItems = () => {
        let array = [];
        for (var i = 1; i < 10; i++) {
            array.push(<li className='test' key={i}>{i}</li>);
        }
        return array;
    }

    const renderTest = () => {
        return (
            <>
                <div className={showNotifBox ? 'notif-box shadow open' : 'notif-box shadow'}>
                    <div className='mt-1'>
                        <i onClick={() => { showBox(false) }} className="bi bi-x-lg"></i>
                    </div>
                    <div className='mb-3'>
                        <h5>تماس ها:</h5>
                        {callers.map((item, index) => (
                            <div className='p-3 border border-1 mb-2' key={index}>
                                <div className='row'>
                                    <div className='col-4'>
                                        {item.firstname} {item.lastname}
                                    </div>
                                    <div className='col-4'>
                                        موبایل {item.phoneNumber}
                                    </div>
                                    <div className='col-4'>
                                        اشتراک: {item.merchantCode}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <ul>
                    {getPagerItems()}
                </ul>
            </>
        )
    };

    return (
        <>
            {renderTest()}
        </>
    );
}

export default Test;